require("!!/opt/atlassian/pipelines/agent/build/node_modules/script-loader/addScript.js")(require("!!/opt/atlassian/pipelines/agent/build/node_modules/raw-loader/index.js!/opt/atlassian/pipelines/agent/build/src/assets/inspinia/plugins/d3/d3.min.js"))


//////////////////
// WEBPACK FOOTER
// ./node_modules/script-loader!./src/assets/inspinia/plugins/d3/d3.min.js
// module id = 2179
// module chunks = 1